import { useEffect, useState } from "react";

import {
  FundraiserLink,
  TestimonialDisplay,
  SomethingForEveryone,
  FundraisingAtScale,
  WhatWeDoForYou,
  ContactUs,
} from "../components/HomePageComponents";

const HomePage = () => {
  useEffect(() => {
    document.title = "MamFam Home";
  }, []);

  return (
    <div>
      {/* <FundraiserLink /> */}
      <SomethingForEveryone />
      <FundraisingAtScale />
      <WhatWeDoForYou />

      {/* This still has InstaRaise text - pending Justin for new Testimonials */}
      {/* <TestimonialDisplay /> */}
      <ContactUs />
    </div>
  );
};

export default HomePage;
